import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "Gallery", path: "/gallery" },
    { name: "Lessons", path: "/lessons" },
    { name: "About Us", path: "/aboutus" },
    { name: "Wood Care Guide", path: "/care" },
    { name: "Contact", path: "/contact" }
  ];

  return (
    <footer className="bg-walnut-900 text-linen-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-display text-linen-50 text-lg font-semibold mb-4">Tree to Table</h3>
            <p className="text-linen-200/70">
              Crafting beautiful wooden pieces from sustainable materials since 2023.
            </p>
          </div>
          <div>
            <h3 className="font-display text-linen-50 text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-linen-200/70 hover:text-copper-400 transition"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-display text-linen-50 text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="text-linen-200/70 space-y-2">
              <li>Email: john@treetotablespokane.com</li>
              <li>Phone: (509) 990-1886</li>
              <li>Location: Spokane, WA</li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-walnut-700">
          <p className="text-center text-linen-200/70">
            © {new Date().getFullYear()} Tree to Table. All rights reserved.
          </p>
          <p className="text-center text-linen-200/70 text-sm mt-2">
            <a
              href="https://www.scoutandanvil.com"
              className="hover:text-copper-400 transition"
            >
              Site by Scout &amp; Anvil
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;